import { getFirestore, collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { getDb } from './firebase';

// Blog verilerini JSON dosyasına kaydet
export const saveBlogToJson = async (blogData) => {
  try {
    const db = await getDb();
    
    // Mevcut blog verilerini oku
    const response = await fetch('/static/blogs.json');
    let blogs = await response.json();

    // Yeni blog verisini ekle veya güncelle
    const existingBlogIndex = blogs.findIndex(blog => blog.id === blogData.id);
    if (existingBlogIndex !== -1) {
      blogs[existingBlogIndex] = { ...blogData };
    } else {
      blogs.push({ ...blogData });
    }

    // JSON dosyasına kaydet
    await fetch('/static/blogs.json', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(blogs),
    });

    console.log('Blog verileri JSON dosyasına kaydedildi');
    return true;
  } catch (error) {
    console.error('Blog verisi JSON dosyasına kaydedilirken hata:', error);
    throw error;
  }
};

// Blog verisini JSON dosyasından sil
export const deleteBlogFromJson = async (blogId) => {
  try {
    // Mevcut blog verilerini oku
    const response = await fetch('/static/blogs.json');
    let blogs = await response.json();

    // Blog verisini sil
    blogs = blogs.filter(blog => blog.id !== blogId);

    // JSON dosyasına kaydet
    await fetch('/static/blogs.json', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(blogs),
    });

    console.log('Blog verisi JSON dosyasından silindi');
    return true;
  } catch (error) {
    console.error('Blog verisi JSON dosyasından silinirken hata:', error);
    throw error;
  }
};

export const generateStaticBlogData = async () => {
  try {
    // JSON dosyasından blog verilerini oku
    const response = await fetch('/static/blogs.json');
    const blogs = await response.json();
    
    console.log('Blog verileri JSON dosyasından okundu.');
    return blogs;
  } catch (error) {
    console.error('Blog verileri okunurken hata:', error);
    // Hata durumunda boş bir dizi döndür
    return [];
  }
};

// Otomatik güncellemeyi kaldırıyoruz çünkü hatalara neden oluyor
// setInterval(generateStaticBlogData, 5 * 60 * 1000); 